import React from 'react';
import { Dialog } from '@material-ui/core';

import { Flex, Text, ButtonFilled } from '../../../Components/Base';
import { useQuizContext } from '../../../Context/QuizContext';

const QuizErrorModal = () => {
  const { error, setError } = useQuizContext();
  const { message, textButton, onContinue } = error || {};
  const handleContinue = () => {
    onContinue();
    setError(null);
  };
  return (
    <Dialog open={error !== null && error !== undefined} maxWidth={'xs'} fullWidth={true}>
      <Flex flexDirection={'column'} alignItems={'center'} p={7}>
        <Text textStyle={'heading5'} mb={7} fontWeight={400} textAlign={'left'}>
          {message}
        </Text>
        <ButtonFilled onClick={handleContinue} minWidth={'150px'}>
          {textButton || 'ปิด'}
        </ButtonFilled>
      </Flex>
    </Dialog>
  );
};

export default QuizErrorModal;
